import { type SignInPhoneSchema, signInPhoneSchema } from '@coas/validators/payload';
import { zodResolver } from '@hookform/resolvers/zod';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { AuthButton } from '~/entities/AuthButton';
import { PhoneNumberInput } from '~/entities/PhoneNumberInput';
import { useSignInMutation } from '../model/mutations';

export const PhoneForm = () => {
    const { mutate, isPending } = useSignInMutation();
    const { control, handleSubmit } = useForm<SignInPhoneSchema>({
        resolver: zodResolver(signInPhoneSchema),
        defaultValues: { provider: 'phone', data: { phoneNumber: '' } },
        mode: 'onTouched',
    });

    const onSubmit = useCallback((values: SignInPhoneSchema) => mutate(values), [mutate]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='flex flex-col gap-4'>
            <PhoneNumberInput name='data.phoneNumber' control={control} label='Номер телефона' disabled={isPending} />
            <AuthButton type='submit' isLoading={isPending}>
                Войти
            </AuthButton>
        </form>
    );
};
